module.exports = __webpack_public_path__ + "static/media/testfile_ssgeneration.03ab8270.zip";